import JPlayer from './JPlayer';

export default class JPlayerMobilePlayer extends JPlayer {
  /**
   * Overriding the JPlayer's destroy method to keep
   * the JPlayerMobilePlayer from destroying itself
   * since it is loaded as a singleton. (See JPlayerFactory.)
   */
  destroy() {
    this.jPlayerLibrary.off();
    this.jPlayerLibrary.jPlayer('clearMedia');
  }
}
